<script setup lang="ts">
import { isMobileView } from "../../utils/GeneralUtils.ts";
import { PropType } from "vue";
import { Project } from "../../types/PersologOnlineTypes.ts";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps({
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
    projectMenuItems: {
        type: Array as PropType<{ visible: boolean; name: string; label: string; command: () => void; icon?: string }[]>,
        required: true,
    },
});

const emit = defineEmits(["update:enableEditMode"]);
</script>

<template>
    <div class="basis-full md:flex-1 flex justify-between md:justify-end">
        <div class="px-0 flex-1 flex md:gap-2 justify-between md:justify-end items-start">
            <SplitButton
                :id="`project-details-menu_btn_edit-${project.id}`"
                outlined
                @click="emit('update:enableEditMode', true)"
                autofocus
                :model="projectMenuItems"
            >
                <i class="pi pi-pencil"></i>
                <span class="ml-2">{{ isMobileView() ? "" : t("buttons.edit") }}</span>
            </SplitButton>
        </div>
    </div>
</template>
